export const firebaseConfig: { [env: string]: Object } = {
  local: {
    apiKey: "AIzaSyAkzrprasyX0YBgZPeI_aPYGFmdp-c1kIg",
    authDomain: "lovefood-80395.firebaseapp.com",
    projectId: "lovefood-80395",
    storageBucket: "lovefood-80395.appspot.com",
    messagingSenderId: "1010831546220",
    appId: "1:1010831546220:web:5153775c9f29e81c5f0549",
    measurementId: "G-EN8Z2FK73C"
  },
  production: {
    apiKey: "AIzaSyBy5tcmvgcfmCa2claQRNqWeFUTdcNLUWQ",
    authDomain: "lovefood-eca17.firebaseapp.com",
    projectId: "lovefood-eca17",
    storageBucket: "lovefood-eca17.appspot.com",
    messagingSenderId: "789145744807",
    appId: "1:789145744807:web:98345de06c4093b133b282",
    measurementId: "G-SE3CDF0404"
  }
}